export const getGraphHeaders = (appName = 'tag_dev', appVersion = 'unknown') => ({
	'x-client-application': appName,
	'x-client-version': appVersion,
});
